import React from "react";
import {
  NavAlert,
  Navbar,
  Sidebar,
  Hero,
  About,
  Projects,
  ContactPage,
} from "../components";

const HomePage = () => {
  return (
    <>
      <main>
        <NavAlert />
        <Navbar />
        <Sidebar />
        <Hero />
        <About />
        <Projects />
        <ContactPage />
      </main>
    </>
  );
};
export default HomePage;
